// import React, { useState } from "react";
// import "./style.scss";
// import { AiOutlineFileJpg } from "react-icons/ai";
// import { PlusOutlined } from "@ant-design/icons";
// import { Image, Upload } from "antd";
// const getBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });
// const ImageUpload = ({imageCount =1}) => {
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [previewImage, setPreviewImage] = useState("");
//   const [fileList, setFileList] = useState([]);
//   const handlePreview = async (file) => {
//     if (!file.url && !file.preview) {
//       file.preview = await getBase64(file.originFileObj);
//     }
//     setPreviewImage(file.url || file.preview);
//     setPreviewOpen(true);
//   };
//   const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
//   const uploadButton = (
//     <button
//       style={{ border: 0, background: "none" }}
//       className="flex flex-col items-center"
//       type="button"
//     >
//       <AiOutlineFileJpg size={25} />
//       <div style={{ marginTop: 8 }}>Upload Image</div>
//     </button>
//   );
//   return (
//     <div className=" w-[60%] flex items-center justify-center">
//       <Upload
//         accept="image/*"
//         action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
//         listType="picture-circle"
//         fileList={fileList}
//         onPreview={handlePreview}
//         onChange={handleChange}
//         className="upload-conatainer   upload-container"
//       >
//         {fileList.length >= imageCount ? null : uploadButton}
//       </Upload>
//       {previewImage && (
//         <Image
//           styles={{ root: { display: "none" } }}
//           preview={{
//             open: previewOpen,
//             onOpenChange: (visible) => setPreviewOpen(visible),
//             afterOpenChange: (visible) => !visible && setPreviewImage(""),
//           }}
//           src={previewImage}
//         />
//       )}
//     </div>
//   );
// };
// export default ImageUpload;


// import React, { useState } from "react";
// import "./style.scss";
// import { AiOutlineFileJpg } from "react-icons/ai";
// import { Image, Upload } from "antd";

// /* Convert file to base64 for preview */
// const getBase64 = (file) =>
//   new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(file);
//     reader.onload = () => resolve(reader.result);
//     reader.onerror = (error) => reject(error);
//   });

// const ImageUpload = ({ imageCount = 1 }) => {
//   const [previewOpen, setPreviewOpen] = useState(false);
//   const [previewImage, setPreviewImage] = useState("");
//   const [fileList, setFileList] = useState([]);

//   const handlePreview = async (file) => {
//     if (!file.url && !file.preview) {
//       file.preview = await getBase64(file.originFileObj);
//     }
//     setPreviewImage(file.url || file.preview);
//     setPreviewOpen(true);
//     console.log("TTTTTTTTTTTTTT")
//   };

//   const handleChange = ({ fileList: newFileList }) =>
//     setFileList(newFileList);

//   const uploadButton = (
//     <button
//       type="button"
//       style={{ border: 0, background: "none" }}
//       className="flex flex-col items-center"
//     >
//       <AiOutlineFileJpg size={26} />
//       <div style={{ marginTop: 8 }}>Upload Image</div>
//     </button>
//   );

//   return (
//     <div className="w-[60%] flex justify-center items-center">
//       <Upload
//         accept="image/*"
//         action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
//         listType="picture-circle"
//         fileList={fileList}
//         onPreview={handlePreview}
//         onChange={handleChange}
//         className="upload-container"
//       >
//         {fileList.length >= imageCount ? null : uploadButton}
//       </Upload>

//       {/* Preview Image (hidden but controls modal) */}
//       {previewImage && (
//         <Image
//           src={previewImage}
//           preview={{
//             open: previewOpen,
//             maskClosable: true,
//             onOpenChange: (visible) => setPreviewOpen(visible),
//             afterOpenChange: (visible) =>
//               !visible && setPreviewImage(""),
//           }}
//           style={{ display: "none" }}
//         />
//       )}
//     </div>
//   );
// };

// export default ImageUpload;

import React, { useState } from "react";
import { AiOutlineFileJpg } from "react-icons/ai";
import { Upload, Modal } from "antd";
import "./style.scss";
import { toast } from "react-toastify";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const ImageUpload = ({ imageCount = 1 ,submitImage,minimumUpload=1}) => {
  const [fileList, setFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  const handlePreview = async (file) => {
    const src = file.url || file.preview || (await getBase64(file.originFileObj));
    setPreviewImage(src);
    setPreviewTitle(file.name || "Preview");
    setPreviewOpen(true);
  };

  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);


  const handleCancel = () => setPreviewOpen(false);

  const handleImageSubmit = () => {
    // Extract actual File objects from AntD fileList
    const filesArray = fileList.map((f) => f.originFileObj).filter(Boolean);
    // console.log("Files to submit:", filesArray);


    if(filesArray.length<minimumUpload){
      toast.warn("Please upload minimum "+minimumUpload+" images", { position: "top-center" });
      return
    }
    // Call parent callback if provided
    if (submitImage) submitImage(filesArray);
  }

  const uploadButton = (
    <button
      type="button"
      style={{ border: 0, background: "none" }}
      className="flex flex-col items-center"
    >
      <AiOutlineFileJpg size={26} />
      <div style={{ marginTop: 8 }}>Upload Image</div>
    </button>
  );

  return (
    <div className="w-[60%] flex flex-col justify-center items-center ">
      <Upload
        accept="image/*"
        // action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
        listType="picture-circle"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
        beforeUpload={() => false}
        className="upload-container"
      >
        {fileList.length >= imageCount ? null : uploadButton}
      </Upload>

      <button className="upload-button" onClick={handleImageSubmit}>
         Submit
      </button>

      <Modal
        open={previewOpen}
        title={previewTitle}
        footer={null}
        onCancel={handleCancel}
      >
        <img alt="preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
};

export default ImageUpload;

